
  export const formatter =(zone, currency)=> new Intl.NumberFormat(`en-${zone}`, {
    style: 'currency',
    currency: currency
  
  });

  